// extracted by mini-css-extract-plugin
export default {"root":"ActivitiesTable_root__zbgmt","percentage":"ActivitiesTable_percentage__9HGNX","checkIcon":"ActivitiesTable_checkIcon__pATcz"};